import React from "react";
import ReminderComponent from './ReminderComponent';
import AddNewItemComponent from "./AddNewItemComponent";
import Button from 'react-bootstrap/Button';
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import moment from 'moment';
import Form from 'react-bootstrap/Form';

function TaskActionsSection({
	activeSection,
	showTopFields,
	isRecurringTask,
	currentItem,
	contexturl,
	reminderTime,
	reminderEndTime,
	reminderType,
	completedDate,
	actualEffortInMins,
	selectedCategories,
	taskName,
	currentEffort,
	currentPriority,
	currentArea,
	timeconstraint,
	onReminderTypeChange,
	onAutoReminderEndTimeChange,
	onReminderTimeChange,
	handleCompletedDateChange,
	handleActualEffortInMinsChange,
	onItemAdded,
	handeMarkAsCompletedButton,
	doSave,
	reschedule,
	discard,
	markingAsComplete,
	saving,
	discarding,
}) {
	const scheduleMode = activeSection === 'REMINDER' && !showTopFields;

	return <>
		{!isRecurringTask && activeSection === 'REMINDER' &&
			<ReminderComponent
				reminderEndTime={reminderEndTime}
				onReminderTypeChange={onReminderTypeChange}
				reminderType={reminderType}
				currentPriority={currentPriority}
				currentEffort={currentEffort}
				currentArea={currentArea}
				currentItem={currentItem}
				contexturl={contexturl}
				reminderTime={reminderTime}
				changeEndTime={onAutoReminderEndTimeChange}
				onChangeTime={onReminderTimeChange}
				reschedule={reschedule}
				saving={saving}
			/>
		}

		{activeSection === 'COMPLETED' && <>
			<Form.Group className="mb-3">
				<Form.Label>Completed Date</Form.Label>
				<Datetime initialViewDate={moment(new Date())} initialViewMode={'time'} dateFormat="DD-MMM-YYYY" timeFormat="HH:mm" timeConstraints={timeconstraint} value={moment(completedDate)} closeOnSelect={true} onChange={handleCompletedDateChange} />
			</Form.Group>
			{!isRecurringTask && <>
				<Form.Group className="mb-3">
					<Form.Label>Approximate time Spent (mins)</Form.Label>
					<Form.Control min="0" type="number" placeholder="Approximate time Spent" value={actualEffortInMins} onChange={handleActualEffortInMinsChange} />
				</Form.Group>
				<Form.Group className="mb-3">
					<Form.Label>Mark as Completed and Add New</Form.Label>
					<AddNewItemComponent categories={selectedCategories} parentTaskName={taskName} parentTaskId={currentItem.taskDetails.id} effort={currentEffort} priority={currentPriority} showFollowUp="true" completed="false" area={currentItem.taskDetails.area} project={currentItem.taskDetails.project} contexturl={contexturl} onItemAdded={onItemAdded} text='asdf' />
				</Form.Group>
			</>}
		</>}

		<div className="d-flex gap-2 mt-3">
			{!scheduleMode && !showTopFields && <Button variant="success" onClick={handeMarkAsCompletedButton}>{markingAsComplete ? 'Marking as Complete...' : 'Mark as Complete'}</Button>}
			{!scheduleMode && !showTopFields && <Button variant="danger" onClick={discard}>{discarding ? 'Discarding...' : 'Discard'}</Button>}
			{!isRecurringTask && !completedDate && <>
				{showTopFields && activeSection !== 'REMINDER' && <Button onClick={doSave}>{saving ? 'Saving...' : 'Save'}</Button>}
			</>}
		</div>
	</>;
}

export default TaskActionsSection;
